// extracted by mini-css-extract-plugin
module.exports = {"select":"index_select__3kEei"};